import invariant from 'invariant';
import { type ReactNode, createContext, use } from 'react';

import type { AppConfig } from '#/config/types/AppConfig';

const AppConfigContext = createContext<AppConfig | null>(null);

export function AppConfigContextProvider({
  appConfig,
  children,
}: {
  appConfig: AppConfig;
  children: ReactNode;
}) {
  return <AppConfigContext value={appConfig}>{children}</AppConfigContext>;
}

export function useAppConfig() {
  const appConfig = use(AppConfigContext);
  invariant(appConfig !== null, 'App config not available');

  return { appConfig };
}

export function useIsUsingAlgoliaMock() {
  const { appConfig } = useAppConfig();

  return { isUsingAlgoliaMock: appConfig.algolia.mock };
}
